import "./styles.scss";
import {initGallery} from "./helpers";

document.addEventListener('DOMContentLoaded', function () {
	const backUp = document.getElementById('backUp');

	window.addEventListener('scroll', () => {
		if (window.scrollY > (window.innerHeight * 0.8)) {
			backUp.style.display = 'flex';
		} else {
			backUp.style.display = 'none';
		}
	});

	backUp.addEventListener('click', () => {
		window.scrollTo({
			behavior: 'smooth',
			top: 0
		});
	});

	document.querySelectorAll('a[href^="#"]').forEach(anchor => {
		anchor.addEventListener('click', function (e) {
			e.preventDefault();

			document.querySelector(this.getAttribute('href')).scrollIntoView({
				behavior: 'smooth'
			});
		});
	});

	initGallery();
});
